import React from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IClientAlreadyExistsWarningDialogProps {
    dialogName: string;
    hideDialog: () => void;
    onConfirm: () => void;
    label?: string;
    heading?: string;
}

// Mirrors WarningDialog.tsx's OK/Cancel shape (title, centered warning icon + label, OK + Cancel)
// rather than NoSelectedInvoicesWarningDialog.tsx's single-Close version - this warning fires from
// FindClientDialog.tsx's Add Client mode when the entered name matches an existing client, and the
// user still needs a way to proceed anyway: OK completes the save as-is (props.onConfirm), Cancel
// aborts and returns to the Add Client form (props.hideDialog).
const ClientAlreadyExistsWarningDialog = (props: IClientAlreadyExistsWarningDialogProps) => {

    return (
        <Dialog title={props?.heading ? props?.heading : ''} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '25%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    ⚠️
                    <label>{!!props?.label ? props?.label : ``}</label>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => props.onConfirm()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default ClientAlreadyExistsWarningDialog;



// WEBPACK FOOTER //
// ./src/components/client-project/dialogs/ClientAlreadyExistsWarningDialog.tsx